const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Track page views automatically (Backend + Google Analytics)
 */
export const trackPageView = async (pageName) => {
  // Send to Google Analytics if available and consent granted
  if (typeof window.gtag !== 'undefined' && localStorage.getItem('cookieConsent') === 'accepted') {
    // Pour GA4, utiliser /home au lieu de / pour une meilleure lisibilité dans les rapports
    const gaPagePath = pageName === '/' ? '/home' : pageName;
    const pageTitle = document.title || 'Home - World Underwater Macro Awards 2026';
    
    window.gtag('event', 'page_view', {
      page_path: gaPagePath,  // Envoie '/home' pour la homepage
      page_title: pageTitle
    });
  }

  // Send to Meta Pixel on SPA route changes if consent granted
  if (typeof window.fbq !== 'undefined' && localStorage.getItem('cookieConsent') === 'accepted') {
    window.fbq('track', 'PageView');
  }
  
  // Send to backend analytics (garde le vrai path)
  try {
    await fetch(`${API_URL}/api/analytics/track-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event_type: 'page_view',
        event_data: {
          page: pageName,  // Backend reçoit toujours le vrai path
          timestamp: new Date().toISOString()
        }
      })
    });
  } catch (error) {
    // Silently fail - analytics should not break the app
    console.debug('Analytics tracking failed:', error);
  }
};

/**
 * Track user login events
 */
export const trackLogin = async (userEmail) => {
  try {
    await fetch(`${API_URL}/api/analytics/track-event`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        event_type: 'login',
        event_data: {
          email: userEmail,
          timestamp: new Date().toISOString()
        }
      })
    });
  } catch (error) {
    console.debug('Login tracking failed:', error);
  }
};
